import { createSelector } from 'reselect';

const selectPageMenuDomain = state => state.PageMenu;

const makeSelectSelectedPagemenu = () =>
  createSelector(selectPageMenuDomain, substate => substate.selectedPageMenu);

export default selectPageMenuDomain;
export { makeSelectSelectedPagemenu };
